import React, { useEffect, useState } from 'react';
import CardForm from './CardForm';
import SocialMedia from './SocialMedia';
import styles from './Contact.module.scss';
import { Row, Col, Container } from 'react-bootstrap';

const apiUrl = process.env.REACT_APP_API_URL || '';

const Contact = () => {
    const [whatsappUrl, setWhatsappUrl] = useState<string>('');
    const [whatsappNumber, setWhatsappNumber] = useState<string>('');

    const formatPhone = (phone: string): string => {
        const match = phone.match(/^(55)?(\d{2})(\d{1})(\d{4})(\d{4})$/);
        if (!match) return phone; // retorna o original se não bater o padrão
        const [, , ddd, firstDigit, firstPart, secondPart] = match;
        return `(${ddd}) ${firstDigit} ${firstPart}-${secondPart}`;
      };

    useEffect(() => {
        // Substitua pela URL real do seu endpoint
        fetch(`${apiUrl}/public/info`)
            .then(async (res) => {
                const resJson = await res.json();
                if (!res.ok) {
                    console.error('Erro na resposta da API: ', resJson);
                    return Promise.reject(resJson.message || 'Ocorreu um erro desconhecido.');
                }
                return resJson;
            })
            .then((data) => {
                const info: Info = data;
                const whatsapp = info['professionalPhone'].replace(/\D/g, '');

                setWhatsappUrl(whatsapp ? `https://wa.me/${whatsapp}` : '');
                setWhatsappNumber(whatsapp ? formatPhone(whatsapp) : '');
            })
            .catch((err) => {
                console.error('Erro ao carregar links sociais:', err);
                //alert('Erro ao carregar links sociais: ' + err);
            });
    }, []);

    return (
        <Container className={styles["container"]}>
            <Row className={[styles["data-content"], "align-items-center"].join(' ')} id="contato">
                <Col md="6" className={[styles["text-content"], styles["center"]].join(" ")}>
                    <h2>Agendamentos</h2>
                    <p>Os atendimentos podem ser realizados de forma individual ou coletiva, de acordo com a sua preferência. As opções incluem casas de repouso, famílias, casais, palestras educativas, e outros formatos adaptados às suas necessidades.</p>
                    <h6 className={styles["whatsapp-info"]}>
                        <a href={whatsappUrl}>WhatsApp: {whatsappNumber}</a>
                    </h6>
                    <Container className={styles["social-media"]}>
                        <SocialMedia />
                    </Container>
                </Col>
                <Col md="6" className={styles["text-content"]}>
                    <CardForm
                        id="contato-form"
                        title="Entre em contato"
                        action={apiUrl + "/contact/send-email"}
                        method="POST"
                        fields={[
                            { name: 'nome', type: 'text', label: 'Nome', required: true },
                            { name: 'email', type: 'email', label: 'Email', required: true },
                            { name: 'telefone', type: 'tel', label: 'Telefone', required: true },
                            { name: 'mensagem', type: 'textarea', label: 'Mensagem', required: true },
                        ]}
                        onSubmit={async (_formData, action, method) => {
                            const formElement = document.getElementById('form-contato-form') as HTMLFormElement;

                            if (!formElement) throw new Error('Formulário não encontrado');

                            const rawFormData = new FormData(formElement);
                            const body = new URLSearchParams();

                            const entries = Array.from(rawFormData.entries());

                            for (const [key, value] of entries) {
                                body.append(key, value.toString());
                            }

                            const response = await fetch(action, {
                                method,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                },
                                body: method === 'POST' ? body.toString() : undefined,
                            });

                            if (!response.ok) {
                                const errorData = await response.json();
                                throw new Error(errorData.message || 'Erro ao enviar formulário');
                            }

                            const responseData = await response.json();

                            // Oculta os campos após envio bem-sucedido
                            formElement.querySelectorAll('.mb-3, button')?.forEach((el) => {
                                (el as HTMLElement).style.display = 'none';
                            });

                            return {
                                message: responseData.message || 'Formulário enviado com sucesso!',
                                errorCode: 0,
                            };
                        }}

                    />
                </Col>
            </Row>
        </Container>
    );
}

export default Contact;
